module.exports = __webpack_public_path__ + "media/images/list-card-pattern-4601c06e.svg";